var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _line, _line2, _g11, _g12, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 820",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "g1",
    cx: "73%",
    cy: "45%",
    r: "42%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b89a5a",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#b89a5a",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b89a5a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: "78%",
    cy: "62%",
    r: "34%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a8878",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a8878",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: "72%",
    cy: "44%",
    r: "16%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d4b87a",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d4b87a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "nodeGold",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d4b87a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b89a5a",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "nodeTeal",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#24a88a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a7a68",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flowGold1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b89a5a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#b89a5a",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b89a5a",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flowGold2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b89a5a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#b89a5a",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b89a5a",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flowTeal",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a8878",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#1a8878",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a8878",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gridMask"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "73%",
    cy: "75%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 820,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leftBleed",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#050504",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#050504",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 820,
    fill: "url(#g1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 820,
    fill: "url(#g2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 820,
    fill: "url(#g3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gridMask)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#b89a5a",
    strokeWidth: 0.5,
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 0,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 140,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 300,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 460,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 600,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 720,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 830,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 920,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 990,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1040,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1100,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1170,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1260,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1360,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1440,
    y2: 820
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1440,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1440,
    y2: 550
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 370,
    x2: 1440,
    y2: 440
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#b89a5a",
    strokeWidth: 0.5,
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 460,
    x2: 1440,
    y2: 460
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 545,
    x2: 1440,
    y2: 545
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 630,
    x2: 1440,
    y2: 630
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 715,
    x2: 1440,
    y2: 715
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 790,
    x2: 1440,
    y2: 790
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 68,
    stroke: "#b89a5a",
    strokeWidth: 0.8,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 118,
    stroke: "#b89a5a",
    strokeWidth: 0.6,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 185,
    stroke: "#b89a5a",
    strokeWidth: 0.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 270,
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 375,
    stroke: "#1a8878",
    strokeWidth: 0.4,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 495,
    stroke: "#1a8878",
    strokeWidth: 0.3,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972 300 A 118 118 0 0 1 1140 395",
    stroke: "#d4b87a",
    strokeWidth: 1.2,
    opacity: 0.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 760 368 A 280 280 0 0 1 890 130",
    stroke: "#24a88a",
    strokeWidth: 0.8,
    opacity: 0.22,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1040 253 A 115 115 0 0 1 1150 415",
    stroke: "#b89a5a",
    strokeWidth: 0.5,
    strokeDasharray: "4 6",
    opacity: 0.25,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10 155 C 220 140, 560 240, 1040 368",
    stroke: "url(#flowGold1)",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 368 C 180 355, 480 362, 820 365 C 910 366 970 367 1040 368",
    stroke: "url(#flowGold2)",
    strokeWidth: 0.8,
    strokeDasharray: "5 9",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 590 C 200 555, 520 470, 1040 368",
    stroke: "url(#flowTeal)",
    strokeWidth: 0.8,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 280 C 300 265, 650 300, 1040 368",
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    strokeDasharray: "2 7",
    opacity: 0.15
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 368,
    x2: 1320,
    y2: 105,
    stroke: "#b89a5a",
    strokeWidth: 0.7,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 368,
    x2: 1440,
    y2: 368,
    stroke: "#b89a5a",
    strokeWidth: 0.6,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 368,
    x2: 1340,
    y2: 588,
    stroke: "#1a8878",
    strokeWidth: 0.7,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 368,
    x2: 1040,
    y2: 55,
    stroke: "#b89a5a",
    strokeWidth: 0.5,
    strokeDasharray: "3 6",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 368,
    x2: 1440,
    y2: 210,
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    strokeDasharray: "2 8",
    opacity: 0.14
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 285,
    r: 6,
    fill: "#b89a5a",
    opacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 285,
    r: 2.5,
    fill: "url(#nodeGold)",
    opacity: 0.85
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 237,
    r: 5,
    fill: "#b89a5a",
    opacity: 0.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 237,
    r: 2,
    fill: "url(#nodeGold)",
    opacity: 0.65
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1231,
    cy: 177,
    r: 4,
    fill: "#b89a5a",
    opacity: 0.04
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1231,
    cy: 177,
    r: 1.5,
    fill: "#d4b87a",
    opacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 130,
    r: 1,
    fill: "#d4b87a",
    opacity: 0.45
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1158,
    cy: 368,
    r: 5,
    fill: "#b89a5a",
    opacity: 0.06
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1158,
    cy: 368,
    r: 2,
    fill: "url(#nodeGold)",
    opacity: 0.7
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 368,
    r: 1.5,
    fill: "#b89a5a",
    opacity: 0.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1340,
    cy: 368,
    r: 1,
    fill: "#b89a5a",
    opacity: 0.35
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 460,
    r: 5,
    fill: "#1a8878",
    opacity: 0.07
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 460,
    r: 2,
    fill: "url(#nodeTeal)",
    opacity: 0.7
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 515,
    r: 1.5,
    fill: "#24a88a",
    opacity: 0.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1285,
    cy: 580,
    r: 1,
    fill: "#24a88a",
    opacity: 0.35
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 250,
    r: 5,
    fill: "#b89a5a",
    opacity: 0.06
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 250,
    r: 2,
    fill: "url(#nodeGold)",
    opacity: 0.65
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 183,
    r: 1.5,
    fill: "#b89a5a",
    opacity: 0.4
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 118,
    r: 1,
    fill: "#b89a5a",
    opacity: 0.3
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 152,
    r: 2,
    fill: "url(#nodeGold)",
    opacity: 0.55
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 228,
    r: 1.5,
    fill: "#b89a5a",
    opacity: 0.45
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 294,
    r: 2,
    fill: "url(#nodeGold)",
    opacity: 0.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 340,
    r: 1.5,
    fill: "#b89a5a",
    opacity: 0.45
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 548,
    r: 2,
    fill: "url(#nodeTeal)",
    opacity: 0.55
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 476,
    r: 1.5,
    fill: "#24a88a",
    opacity: 0.45
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 416,
    r: 2,
    fill: "url(#nodeTeal)",
    opacity: 0.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 28,
    fill: "#b89a5a",
    opacity: 0.04
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 14,
    fill: "#b89a5a",
    opacity: 0.08
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 6,
    fill: "#d4b87a",
    opacity: 0.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 368,
    r: 3,
    fill: "#f2ece0",
    opacity: 0.9
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 294,
    x2: 720,
    y2: 230,
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 230,
    r: 1.5,
    fill: "#b89a5a",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 294,
    x2: 630,
    y2: 240,
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 240,
    r: 1,
    fill: "#b89a5a",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 228,
    x2: 500,
    y2: 170,
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 170,
    r: 1.5,
    fill: "#b89a5a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1123,
    y1: 285,
    x2: 1180,
    y2: 300,
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 300,
    r: 1,
    fill: "#d4b87a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1123,
    y1: 285,
    x2: 1100,
    y2: 210,
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 210,
    r: 1.2,
    fill: "#d4b87a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1125,
    y1: 460,
    x2: 1185,
    y2: 490,
    stroke: "#24a88a",
    strokeWidth: 0.4,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185,
    cy: 490,
    r: 1.2,
    fill: "#24a88a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1125,
    y1: 460,
    x2: 1160,
    y2: 395,
    stroke: "#24a88a",
    strokeWidth: 0.4,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160,
    cy: 395,
    r: 1,
    fill: "#24a88a",
    opacity: 0.35
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b89a5a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1115,
    y: 277,
    width: 10,
    height: 10,
    transform: "rotate(45 1120 282)",
    strokeWidth: 0.9,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1163,
    y: 229,
    width: 7,
    height: 7,
    transform: "rotate(45 1166.5 232.5)",
    strokeWidth: 0.7,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 144,
    width: 9,
    height: 9,
    transform: "rotate(45 216.5 148.5)",
    strokeWidth: 0.7,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 286,
    width: 8,
    height: 8,
    transform: "rotate(45 676 290)",
    strokeWidth: 0.7,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 242,
    width: 7,
    height: 7,
    transform: "rotate(45 1035.5 245.5)",
    strokeWidth: 0.6,
    opacity: 0.38
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#24a88a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 540,
    width: 9,
    height: 9,
    transform: "rotate(45 256.5 544.5)",
    strokeWidth: 0.8,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117,
    y: 452,
    width: 7,
    height: 7,
    transform: "rotate(45 1120.5 455.5)",
    strokeWidth: 0.7,
    opacity: 0.4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#b89a5a",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 224,
    x2: 460,
    y2: 232,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456,
    y1: 228,
    x2: 464,
    y2: 228,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 869,
    y1: 336,
    x2: 869,
    y2: 344,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 865,
    y1: 340,
    x2: 873,
    y2: 340,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1231,
    y1: 173,
    x2: 1231,
    y2: 181,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1227,
    y1: 177,
    x2: 1235,
    y2: 177,
    opacity: 0.4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#24a88a",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 412,
    x2: 760,
    y2: 420,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 756,
    y1: 416,
    x2: 764,
    y2: 416,
    opacity: 0.5
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b89a5a",
    strokeWidth: 0.4,
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1280,52  1315,72  1315,112 1280,132 1245,112 1245,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1350,12  1385,32  1385,72  1350,92  1315,72  1315,32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1210,12  1245,32  1245,72  1210,92  1175,72  1175,32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1280,132 1315,152 1315,192 1280,212 1245,192 1245,152"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1350,92  1385,112 1385,152 1350,172 1315,152 1315,112"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1210,92  1245,112 1245,152 1210,172 1175,152 1175,112"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1280,212 1315,232 1315,272 1280,292 1245,272 1245,232"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "#b89a5a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 110,
    r: 0.9,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 72,
    r: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 125,
    r: 0.8,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 58,
    r: 0.9,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 100,
    r: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590,
    cy: 45,
    r: 0.8,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 88,
    r: 0.9,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 52,
    r: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 94,
    r: 0.8,
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1380,
    cy: 335,
    r: 0.8,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1410,
    cy: 295,
    r: 1,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1420,
    cy: 420,
    r: 0.8,
    opacity: 0.25
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#f2ece0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 55,
    r: 0.8,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 82,
    r: 0.9,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 48,
    r: 0.8,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 70,
    r: 0.9,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 62,
    r: 0.8,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 42,
    r: 1,
    opacity: 0.3
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 368,
    x2: 1018,
    y2: 368,
    stroke: "#b89a5a",
    strokeWidth: 0.6,
    opacity: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 368,
    x2: 1018,
    y2: 368,
    stroke: "#b89a5a",
    strokeWidth: 4,
    opacity: 0.03
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b89a5a",
    strokeWidth: 0.5,
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1390,760 1440,760 1440,820"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1400,775 1440,775"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1a8878",
    strokeWidth: 0.5,
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1370,780 1370,820 1440,820"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 820,
    fill: "url(#leftBleed)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.05b2b0c50f05640ca04d078303d36169.svg";
export { ForwardRef as ReactComponent };